// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"InputGroup_inputGroup__12uS4","formGroup":"InputGroup_formGroup__1WpRE"};